import { type TeamHistory, type TeamId, type UserHistory, type UserId } from '@terros/common'

export type UserChangeType = 'owner' | 'closer'

export type UserChange = {
  type: UserChangeType
  timestamp: number
  userId: UserId
  previousUserId?: UserId
}

export type TeamChange = {
  type: 'team'
  timestamp: number
  teamId: TeamId
  previousTeamId?: TeamId
}

type ToUserChangesProps = {
  type: UserChangeType
  history: UserHistory | undefined
}

/** Each change knows who it replaced, since history entries only store the new assignee */
export const toUserChanges = ({ type, history = [] }: ToUserChangesProps): UserChange[] =>
  [...history]
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item, index, sorted) => ({
      type,
      timestamp: item.timestamp,
      userId: item.userId,
      previousUserId: sorted[index - 1]?.userId,
    }))

export const toTeamChanges = (history: TeamHistory = []): TeamChange[] =>
  [...history]
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item, index, sorted) => ({
      type: 'team',
      timestamp: item.timestamp,
      teamId: item.teamId,
      previousTeamId: sorted[index - 1]?.teamId,
    }))
